function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.28385 68.938C9.28385 64.8208 7.66005 63.4741 4.11994 58.9696C1.5061 55.633 -0.293951 50.4314 0.0398093 45.1344C0.984839 30.0181 3.27241 0 3.27241 0H5.52248V35.75H9.28385L10.1201 0H12.3964L13.0452 35.75H16.8066L17.7141 0H19.8217L20.568 35.75H24.3293V0H26.3882C26.3882 0 28.9157 29.8215 29.9545 44.9854C30.322 50.3599 28.4207 55.6628 25.7469 59.0233C22.188 63.498 20.568 64.785 20.568 68.9678V134.063C20.568 138.996 18.0441 143 14.924 143C11.8077 143 9.28385 138.996 9.28385 134.063V68.938Z",
  fill: "currentColor"
});

var SvgFork = function SvgFork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 143,
    viewBox: "0 0 30 143",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fork.b36d1b4b.svg";
export { ForwardRef as ReactComponent };